
/* styles */
require("!!style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-16773664!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./menu.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./menu.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-16773664!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./menu.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/tofu-menu/src/menu.vue
// module id = 587
// module chunks = 0